import React from "react";
import { Container, Row, Col } from "reactstrap";
import RoleList from "./RoleList";

const Roles = () => {
  return (
    <Container fluid className="p-0">
      <h1 className="page-title">Roles</h1>
      <Row>
        <Col lg="12" className="d-flex">
          <RoleList />
        </Col>
      </Row>
    </Container>
  );
};

export default Roles;
